import { ACCOUNT_RESEARCH } from './skills/accountResearch.js'
import { BOARD_DECK } from './skills/boardDeck.js'
import { MEETING_PREP } from './skills/meetingPrep.js'
import { TRADEMARK_CHECK } from './skills/trademarkCheck.js'
import { WEEKLY_STATUS } from './skills/weeklyStatus.js'

/** Sample saved skills shown under Skills › Mine. */
export const DEMO_SKILLS = [ACCOUNT_RESEARCH, MEETING_PREP, WEEKLY_STATUS, TRADEMARK_CHECK, BOARD_DECK]
